<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-12-17 15:32:10
 * @LastEditTime: 2020-12-30 14:46:31
-->
<template>
  <div>
    <div class="no-permission" v-if="this.Permission.indexOf(226) === -1">
      {{ $t("lang.rightAlarm.Nopermission") }}
    </div>
    <div v-else v-for="(item, index) in alarmList" :key="item.id">
      <el-divider></el-divider>
      <div
        :class="alarmItemSrtyle[index] ? alarmItemSrtyle[index] : 'alarm-item'"
        @click="clickAlarm(item, index)"
      >
        <el-popover placement="left" width="100%" trigger="click">
          <div class="alarm-status">
            <p class="title">{{ $t("lang.rightAlarm.Alarmhandling") }}</p>
            <el-form label-position="right" label-width="120px">
              <el-form-item :label="$t('lang.rightAlarm.Alarmstart')">
                <span>{{ item.sts | formateTime }}</span>
              </el-form-item>
              <el-form-item :label="$t('lang.rightAlarm.Alarmend')">
                <span>{{ item.ets | formateTime }}</span>
              </el-form-item>
              <el-form-item :label="$t('lang.rightAlarm.Alarmresult')">
                <span v-if="item.state == 1">
                  {{ item.description }}
                </span>
                <el-tag size="small" type="danger" v-else>{{
                  $t("lang.rightAlarm.notprocessed")
                }}</el-tag>
              </el-form-item>
              <el-form-item
                v-if="item.state == 0"
                :label="$t('lang.rightAlarm.Processing')"
              >
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="description"
                  :placeholder="$t('lang.rightAlarm.Processing')"
                ></el-input>
              </el-form-item>
            </el-form>
            <div v-if="item.state == 0" class="alarm-status_button">
              <el-button size="mini" type="primary" @click="save(item)">{{
                $t("lang.rightAlarm.save")
              }}</el-button>
            </div>
          </div>
          <div slot="reference">
            <!-- <div>
              <span>{{ $t("lang.rightAlarm.equipment") }}</span>
              <span>{{ item.dname }}</span>
            </div> -->
            <div>
              <span>{{ $t("lang.rightAlarm.terminal") }}</span>
              <span>{{ item.dtuname }}</span>
            </div>
            <div>
              <span>{{ $t("lang.rightAlarm.variable") }}</span>
              <span>{{ item.vname }}</span>
            </div>
            <div>
              <span>{{ $t("lang.rightAlarm.content") }}</span>
              <span>{{ item.alarmContent }}</span>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
import { realTimeAlarm, handleAlarm } from "@/api/cloudMonitor/alarmList";
import { getPermission } from "@/cookie/cookie";
import moment from "moment";
export default {
  props: ["deviceDid"],
  data() {
    return {
      total: 0,
      alarmList: [],
      alarmItemSrtyle: [],
      timer: null, // 实时报警计时器
      description: "", // 处理内容
      Permission: [],
    };
  },
  components: {},
  filters: {
    formateTime(time) {
      if (time) {
        return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
  },
  watch: {
    deviceDid: {
      immediate: true,
      handler() {
        clearInterval(this.timer);
        if (this.deviceDid && this.Permission.indexOf(226) !== -1) {
          this.getAlarmList();
          this.timer = setInterval(() => {
            this.getAlarmList();
          }, 10000);
        }
      },
    },
  },
  activated() {
    clearInterval(this.timer);
    this.Permission = getPermission();
    if (this.deviceDid && this.Permission.indexOf(226) !== -1) {
      this.getAlarmList();
      this.timer = setInterval(() => {
        this.getAlarmList();
      }, 10000);
    }
  },
  deactivated() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取实时报警数据
    getAlarmList() {
      realTimeAlarm(this.deviceDid)
        .then((res) => {
          if (res.data.code === 0) {
            this.alarmList = res.data.data;
          }
        })
        .catch(() => {});
    },
    // 点击了某条报警信息
    clickAlarm(item, index) {
      // 先把之前的置为初始化
      let itemSrtyle = this.alarmItemSrtyle[index];
      this.alarmItemSrtyle.splice(0, this.alarmItemSrtyle.length);
      this.$set(this.alarmItemSrtyle, index, "alarm-item_highlight");
    },
    // 保存处理
    save(item) {
      let params = {
        id: item.id,
        description: this.description,
      };
      handleAlarm(params)
        .then((res) => {
          if (res.data.code === 0) {
            this.getAlarmList();
            this.$message.success(this.$t("lang.rightAlarm.msg1"));
            this.description = "";
          } else {
            this.$message.error(this.$t("lang.rightAlarm.msg2"));
          }
        })
        .catch(() => {
          this.$message.error(this.$t("lang.rightAlarm.msg3"));
        });
    },
  },
};
</script>
<style scoped>
.el-divider {
  background-color: #409eff;
  margin: 0px;
}
.alarm-item,
.alarm-item_highlight {
  font-size: 16px;
  cursor: pointer;
  line-height: 25px;
  padding: 10px 0px 10px 10px;
}
.alarm-item_highlight {
  background-color: #409eff;
}
.title {
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: bolder;
}
.alarm-status {
  padding: 30px;
  font-size: 16px;
  border: 2px solid rgb(0, 116, 199);
  border-radius: 5px;
}
.el-form-item {
  margin-bottom: 0px;
}
.alarm-status_button {
  text-align: center;
  margin-top: 20px;
}
.el-popover {
  border: 2px solid rgb(0, 116, 199);
}
.no-permission {
  text-align: center;
  font-size: 20px;
  color: grey;
}
</style>
